'use client';

import type { LanguageModelUsage } from 'ai';
import { ChatModal } from './chat-modal';
import type { VisibilityType } from './visibility-selector';
import type { ChatMessage } from '@/lib/types';
import type {PromptType} from "@/app/(chat)/api/chat/route";

// Session type definition for stateless mode
type Session = null;

export function Chat({
  id,
  initialMessages,
  initialChatModel,
  initialVisibilityType,
  isReadonly,
  session,
  autoResume,
  initialLastContext,
  initialPromptMode = 'simple',
}: {
  id: string;
  initialMessages: ChatMessage[];
  initialChatModel: string;
  initialVisibilityType: VisibilityType;
  isReadonly: boolean;
  session: Session;
  autoResume: boolean;
  initialLastContext?: LanguageModelUsage;
  initialPromptMode?: PromptType;
}) {
  return (
    <div className="flex h-dvh flex-col">
      {/* Main content area with blue background */}
      <div className='relative flex-1' style={{ backgroundColor: '#000054' }}>
        {/* Modal backdrop only in the middle section */}
        <div className="absolute inset-0 backdrop-blur-sm" />
        
        {/* Chat modal container */}
        <div className='relative z-10 flex h-full items-center justify-center p-4'>
          <div className='flex h-full max-h-[750px] w-full max-w-7xl overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-2xl'>
            <ChatModal
              id={id}
              initialMessages={initialMessages}
              initialChatModel={initialChatModel}
              initialVisibilityType={initialVisibilityType}
              isReadonly={isReadonly}
              session={session}
              autoResume={autoResume}
              initialLastContext={initialLastContext}
              initialPromptMode={initialPromptMode}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
